import {Button, Tabs} from 'antd'
import Table from '@/biz/Table.jsx'
import {Alert, useOpenModal} from '@/components/Modal/index.mjs'
import {useMapContext} from '@/components/MindMap/index.mjs'
import openWindow from '@/script/openWindow.mjs'
import MenuButton from '../MenuButton.jsx'

const useDps = map => {
    const dps = {BDLOGIC: [], DT: []}

    for (const n of map.dfs(map.root.children)) {
        const {bizNodeType} = n.data

        if (dps[bizNodeType]) {
            dps[bizNodeType].push(n.data)
        }
    }

    return dps
}

const TableBdlogic = ({data, ...props}) => {
    const columns = [
        {
            title: '模件编号',
            dataIndex: 'dpSn',
            component: <Table.ViewText />,
            filter: <Table.FilterText/>,
        },
        {
            title: '模件名称/代码',
            key: 'nameCode',
            filter: <Table.FilterText/>,
            getValue: row => `${row.ruleTitle}/${row.ruleUserCode}`,

            render: (value, row) => {
                const onClick = () => {
                    const mapInits = {
                        selectedNodes: [{
                            data: {pkid: row.pkid},
                            isMounted: true,
                        }],
                    }

                    openWindow('/BdDetail', {bdId: row.bdId, mapInits})
                }

                return (
                    <a
                        rel="noreferrer"
                        onClick={onClick}
                    >
                        {value}
                    </a>
                )
            },
        },
        {
            title: '模件版本号',
            key: 'ver',
            component: <Table.ViewText />,
            filter: <Table.FilterText/>,
            getValue: ({rev, sVer}) => `${sVer}.${rev}`,
        },
        {
            title: '所属模块',
            dataIndex: 'bdName',
            component: <Table.ViewText />,
            filter: <Table.FilterText/>,
        },
    ]

    return (
        <Table
            columns={columns}
            dataSource={data}
            rowKey="pkid"
            {...props}
        />
    )
}

const TableDt = ({data, ...props}) => {
    const columns = [
        {
            title: '模件编号',
            dataIndex: 'dpSn',
            component: <Table.ViewText />,
            filter: <Table.FilterText/>,
        },
        {
            title: '模件名称/代码',
            key: 'nameCode',
            filter: <Table.FilterText/>,
            getValue: row => `${row.dtName}/${row.dtUserCode}`,

            render: (value, row) => {
                const onClick = () => {
                    openWindow('/DtDetail', {dtId: row.pkid})
                }

                return (
                    <a
                        rel="noreferrer"
                        onClick={onClick}
                    >
                        {value}
                    </a>
                )
            },
        },
        {
            title: '模件版本号',
            key: 'ver',
            component: <Table.ViewText />,
            filter: <Table.FilterText/>,
            getValue: ({rev, sVer}) => `${sVer}.${rev}`,
        },
        {
            title: '所属模块',
            dataIndex: 'dbName',
            component: <Table.ViewText />,
            filter: <Table.FilterText/>,
        },
    ]

    return (
        <Table
            columns={columns}
            dataSource={data}
            rowKey="pkid"
            {...props}
        />
    )
}

const ModalDpList = ({map, ...props}) => {
    const dps = useDps(map)

    const items = [
        {
            key: 'bdlogic',
            label: '程序能力',
            children: <TableBdlogic data={dps.BDLOGIC} />,
        },
        {
            key: 'dt',
            label: '数据表',
            children: <TableDt data={dps.DT} />,
        },
    ]

    return (
        <Alert
            title="分析制品"
            width={1200}
            {...props}
        >
            <Tabs items={items} />
        </Alert>
    )
}

export default function MenuButtonDpList(props) {
    const openModal = useOpenModal()
    const map = useMapContext()
    const {mapTypeCode} = map.data

    if ('REFERENCE_MAP' !== mapTypeCode) {
        return null
    }

    const onClick = () => openModal(<ModalDpList map={map} />)

    return (
        <MenuButton
            onClick={onClick}
            {...props}
        >
            查看分析制品
        </MenuButton>
    )
}
